export default __webpack_public_path__ + "static/media/bulk-microbulk-banner.f55197e2.jpg";